import React, { Component } from "react";
import { Base } from "zina-dogi-react";
import { NonSodeDashboardReport } from "../components";


class NonSodeDashboardReportContainer extends Component {
    render() {
        const { extraProps } = this.props;
        const base_op = {
            className: "report",
            title: "Non sode dashboard report",
            breadcrumbs: [{ name: "Home", rel: "/", icon: "home" }, { name: "Non sode dashboard report" }],
            extraProps,
            loading: false
        };
        return (
            <Base {...base_op}>
                <NonSodeDashboardReport />
            </Base>
        );
    }
}

export default NonSodeDashboardReportContainer;
